import { render, staticRenderFns } from "./AnimalSubscribe.vue?vue&type=template&id=5f48531b&scoped=true&"
import script from "./AnimalSubscribe.vue?vue&type=script&lang=ts&"
export * from "./AnimalSubscribe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f48531b",
  null
  
)

export default component.exports